module.exports = __webpack_public_path__ + "static/media/female.993493dd.svg";